export const redirects = {
    "/artuncontained": "/arts/artuncontained",
    "/news/events": "/news/community",
    "/news/canada/:path+/events": "/news/canada/:path/community",
    "/news/headlines": "/news",
    "/news/:paths+/headlines": "/news/:paths",
    "/news/covid-19": "/news",
    "/life/the-great-canadian-baking-show": "/life/greatcanadianbakingshow",
    "/life/weddings": "/life/topic/Tag/Weddings",
    "/life/greatcanadianbakingshow/gcbs-bakers":
        "/life/greatcanadianbakingshow/bakers",
    "/life/greatcanadianbakingshow/gcbs-episodes":
        "/life/greatcanadianbakingshow/episodes",
    "/life/greatcanadianbakingshow/gcbs-recipes":
        "/life/greatcanadianbakingshow/recipes",
    "/life/greatcanadianbakingshow/gcbs-about":
        "/life/greatcanadianbakingshow/about",
    "/greatcanadianbakingshow": "/life/greatcanadianbakingshow",
    "/life/the-goods": "/life/thegoods",
    "/life/personalfinance": "/life/work-money",
    "/books/mobile(/*)": "/books",
    "/books/tdkids": "/books/kids",
    "/sports/olympics/cbc-sports-presents": "/sports/shows/cbc-sports-presents",
    "/sports/olympics/crosscountry": "/sports/olympics/winter/skiing",
    "/sports/olympics/biathlon": "/sports/olympics/winter/skiing",
    "/sports/olympics/cycling/road": "/sports/olympics/summer/cycling",
    "/sports/olympics/cycling/track": "/sports/olympics/summer/cycling",
    "/sports/olympics/cycling/bmx": "/sports/olympics/summer/cycling",
    "/sports/olympics/cycling/mountain-bike": "/sports/olympics/summer/cycling",
    "/sports/olympics/skeleton": "/sports/olympics/winter/sliding",
    "/sports/olympics/luge": "/sports/olympics/winter/sliding",
    "/sports/olympics/bobsleigh": "/sports/olympics/winter/sliding",
    "/sports/olympics/shorttrack": "/sports/olympics/winter/speed-skating",
    "/sports/olympics/hockey": "/sports/hockey/nhl",
    "/sports/olympics/hometeam": "/sports/olympics",
    "/sports/nhl": "/sports/hockey/nhl",
    "/sports/hockey/nhl/wharnsby": "/sports/hockey/nhl",
    "/sports/hockey/nhl/wharnsby/:paths+": "/sports/hockey/nhl/:paths",
    "/sports/hockey/nhl/brophy": "/sports/hockey/nhl",
    "/sports/hockey/nhl/brophy/:paths+": "/sports/hockey/nhl/:paths",
    "/sports/hockeynightincanada": "/sports/hockey/nhl",
    "/sports/video/hockey": "/player/sports",
    "/sports/nba": "/sports/basketball",
    "/sports/basketball/nba": "/sports/basketball",
    "/sports/basketball/cebl": "/sports/basketball",
    "/sports/cfl": "/sports/football",
    "/sports/nfl": "/sports/football",
    "/sports/football/cfl": "/sports/football",
    "/sports/football/nfl": "/sports/football",
    "/sports/mlb": "/sports/baseball",
    "/sports/baseball/mlb": "/sports/baseball",
    "/sports/olympics/alpineskiing": "/sports/olympics/winter/alpine-skiing",
    "/sports/olympics/winter/alpineskiing":
        "/sports/olympics/winter/alpine-skiing",
    "/sports/olympics/aquatics": "/sports/olympics/summer/aquatics",
    "/sports/olympics/curling": "/sports/olympics/winter/curling",
    "/sports/olympics/cycling": "/sports/olympics/summer/cycling",
    "/sports/olympics/figureskating": "/sports/olympics/winter/figure-skating",
    "/sports/olympics/winter/figureskating":
        "/sports/olympics/winter/figure-skating",
    "/sports/olympics/freestyleskiing":
        "/sports/olympics/winter/freestyle-skiing",
    "/sports/olympics/winter/freestyleskiing":
        "/sports/olympics/winter/freestyle-skiing",
    "/sports/olympics/gymnastics": "/sports/olympics/summer/gymnastics",
    "/sports/olympics/skiing": "/sports/olympics/winter/skiing",
    "/sports/olympics/sliding": "/sports/olympics/winter/sliding",
    "/sports/olympics/snowboard": "/sports/olympics/winter/snowboard",
    "/sports/olympics/speedskating": "/sports/olympics/winter/speed-skating",
    "/sports/olympics/winter/speedskating":
        "/sports/olympics/winter/speed-skating",
    "/sports/olympics/trackandfield": "/sports/olympics/summer/trackandfield",
    "/sports/olympics/volleyball": "/sports/olympics/summer/volleyball",
    "/sports/winter": "/sports",
    "/sports/summer": "/sports/olympics/summer",
    "/sports/figureskating": "/sports/olympics/winter/figure-skating",
    "/sports/curling": "/sports/olympics/winter/curling",
    "/sports/alpineskiing": "/sports/olympics/winter/alpine-skiing",
    "/sports/moresports": "/sports/all",
    "/sports/videos": "/player/sports",
    "/sports/video": "/player/sports",
    "/sports/paralympics/wheelchair-curling": "/sports/paralympics",
    "/sports/paralympics/ice-hockey": "/sports/paralympics",
    "/sports/paralympics/snowboard": "/sports/paralympics",
    "/sports/paralympics/cross-country-skiing": "/sports/paralympics",
    "/sports/paralympics/alpine-skiing": "/sports/paralympics",
    "/sports/paralympics/biathlon": "/sports/paralympics",
    "/sports/paralympics-temporary-unmap": "/sports/paralympics",
    "/sports/paralympics/summer": "/sports/paralympics",
    "/sports/paralympics/summer/(para-archery|para-athletics|para-badminton|boccia|para-canoe|para-cycling|para-equestrian|para-football-5-a-side|goalball|para-judo|para-powerlifting|para-rowing|shooting-para-sport|sitting-volleyball|para-swimming|para-table-tennis|para-taekwondo|para-triathlon|wheelchair-basketball|wheelchair-fencing|wheelchair-rugby|wheelchair-tennis)":
        "/sports/paralympics",
    "/sports/calgarystampede/video": "/player/sports",
    "/bc": "/news/canada/british-columbia",
    "/british-columbia": "/news/canada/british-columbia",
    "/britishcolumbia": "/news/canada/british-columbia",
    "/calgary": "/news/canada/calgary",
    "/canada": "/news/canada",
    "/edmonton": "/news/canada/edmonton",
    "/kw": "/news/canada/kitchener-waterloo",
    "/kitchener-waterloo": "/news/canada/kitchener-waterloo",
    "/labrador": "/news/canada/newfoundland-labrador",
    "/london": "/news/canada/london",
    "/manitoba": "/news/canada/manitoba",
    "/montreal": "/news/canada/montreal",
    "/nb": "/news/canada/new-brunswick",
    "/newbrunswick": "/news/canada/new-brunswick",
    "/nl": "/news/canada/newfoundland-labrador",
    "/north": "/news/canada/north",
    "/ns": "/news/canada/nova-scotia",
    "/novascotia": "/news/canada/nova-scotia",
    "/nunavut": "/news/canada/north",
    "/ottawa": "/news/canada/ottawa",
    "/pei": "/news/canada/prince-edward-island",
    "/quebec": "/news/canada/montreal",
    "/sask": "/news/canada/saskatchewan",
    "/saskatchewan": "/news/canada/saskatchewan",
    "/saskatoon": "/news/canada/saskatchewan",
    "/sudbury": "/news/canada/sudbury",
    "/thunderbay": "/news/canada/thunder-bay",
    "/toronto": "/news/canada/toronto",
    "/vancouver": "/news/canada/british-columbia",
    "/victoria": "/news/canada/british-columbia",
    "/windsor": "/news/canada/windsor",
    "/radio/outintheopen/what-does-colten-boushie-say-about-us-1.3924855":
        "/radio/outintheopen/i-was-blind-to-the-racial-tension-colten-boushie-s-family-speaks-out-about-the-aftermath-of-his-death-1.4445326",
    "/radio/q": "/arts/q",
    "/sports/commonwealthgames/news": "/sports/commonwealthgames",
    "/sports/commonwealthgames/photos": "/sports/commonwealthgames",
    "/sports/commonwealthgames/results": "/sports/commonwealthgames",
    "/sports/commonwealthgames/medals": "/sports/commonwealthgames",
    "/sports/soccer/brazil2014/photos": "/sports/soccer",
    "/sports/skiing/photos": "/sports/olympics/winter/skiing",
    "/sports/skiing/video": "/player/sports",
    "/sports/video/skiing": "/player/sports",
    "/sports/hockey/nhl/special/Tag/World+Cup+of+Hockey": "/sports/hockey/nhl",
    "/sports/panam": "/sports",
    "/sports/figureskating/headlines": "/sports/olympics/winter/figure-skating",
    "/sports/figureskating/photos": "/sports/olympics/winter/figure-skating",
    "/sports/football/nfl/headlines": "/sports/football",
    "/sports/rugby/video": "/player/sports",
    "/sports/tennis/headlines": "/sports/tennis",
    "/sports/trackandfield/video/live": "/sports/broadcast",
    "/sports/figureskating/photos/3158":
        "/sports/olympics/winter/figure-skating",
    "/sports/basketball/nba/video": "/player/sports",
    "/sports/tennis/video": "/player/sports",
    "/sports/video/tennis": "/player/sports",
    "/sports/figureskating/photos/430":
        "/sports/olympics/winter/figure-skating",
    "/sports/football/cfl/headlines": "/sports/football",
    "/sports/hockey/nhl/video": "/player/sports",
    "/sports/gilletteworldsport/video": "/player/sports",
    "/sports/panam/video": "/player/sports",
    "/sports/soccer/video": "/player/sports",
    "/sports/video/soccer": "/player/sports",
    "/sports/trackandfield/video": "/player/sports",
    "/sports/parapanam/video": "/player/sports",
    "/sports/curling/video": "/player/sports",
    "/sports/video/curling": "/player/sports",
    "/sports/trackandfield/broadcast": "/sports/broadcast",
    "/sports/paralympics/news": "/sports/paralympics",
    "/sports/photos": "/sports",
    "/sports/sprucemeadows/broadcast": "/sports/equestrian/streaming-schedule",
    "/sports/sprucemeadows/video": "/player/sports",
    "/sports/curling/headlines": "/sports/olympics/winter/curling",
    "/sports/basketball/nba/headlines": "/sports/basketball",
    "/sports/sportsday": "/sports",
    "/sports/soccer/fifau20": "/sports/soccer",
    "/sports/golf/photos": "/sports/golf",
    "/sports/curling/photos": "/sports/olympics/winter/curling",
    "/sports/football/cfl/video": "/player/sports",
    "/sports/video/cfl": "/player/sports",
    "/sports/hotcorner": "/sports",
    "/sports/sportsweekend/video": "/player/sports",
    "/sports/skiing/headlines": "/sports/olympics/winter/skiing",
    "/sports/soccer/photos": "/sports/soccer",
    "/sports/basketball/photos": "/sports/basketball",
    "/sports/football/photos": "/sports/football",
    "/sports/baseball/photos": "/sports/baseball",
    "/sports/paralympics/photos": "/sports/paralympics",
    "/sports/trackandfield/photos": "/sports/olympics/summer/trackandfield",
    "/sports/tennis/photos": "/sports/tennis",
    "/sports/hockey/hockeytonightkids/entry/index.php": "/sports/hockey/nhl",
    "/sports/trackandfield/headlines": "/sports/olympics/summer/trackandfield",
    "/sports/headlines": "/sports",
    "/sports/2.720": "/sports",
    "/sports/hockey/nhl/headlines": "/sports/hockey/nhl",
    "/sports/naig/broadcast": "/sports/broadcast",
    "/sports/video/paralympics": "/player/sports",
    "/sports/speedskating": "/sports/olympics/winter/speed-skating",
    "/sports/figureskating/video": "/player/sports",
    "/sports/basketball/2.6127": "/sports/basketball",
    "/sports/soccer/headlines": "/sports/soccer",
    "/sports/hockey/photos": "/sports/hockey/nhl",
    "/sports/trackandfield": "/sports/olympics/summer/trackandfield",
    "/sports/curling/broadcast": "/sports/olympics/winter/curling/broadcast",
    "/sports/football/nfl/video": "/player/sports",
    "/sports/baseball/mlb/video": "/player/sports",
    "/sports/video/baseball": "/player/sports",
    "/sports/golf/video": "/player/sports",
    "/sports/video/golf": "/player/sports",
    "/sports/tennis/broadcast": "/sports/tennis",
    "/sports/skiing": "/sports/olympics/winter/skiing",
    "/sports/baseball/mlb/headlines": "/sports/baseball",
    "/sports/speedskating/video": "/player/sports",
    "/sports/video/speed-skating": "/player/sports",
    "/sports/videos/originals/video": "/player/sports",
    "/sports/golf/headlines": "/sports/golf",
    "/pride": "/pride/topic/Collections/Spotlight%20on%20Pride",
    "/sports/video/university-football": "/player/sports",
    "/sports/video/olympic-sports": "/player/sports",
    "/sports/video/cbc-sports-originals": "/player/sports",
    "/sports/video/figure-skating": "/player/sports",
    "/sports/video/paralympics/cross-country-skiing": "/player/sports",
    "/sports/video/paralympics/hockey": "/player/sports",
    "/sports/video/nfl": "/player/sports",
    "/sports/video/commonwealth-games": "/player/sports",
    "/sports/video/calgary-stampede": "/player/sports",
    "/sports/video/full-shows": "/player/sports",
    "/sports/video/track-and-field": "/player/sports",
    "/sports/video/show-jumping": "/player/sports",
    "/sports/video/paralympics/wheelchair-curling": "/player/sports",
    "/sports/video/paralympics/biathlon": "/player/sports",
    "/sports/video/paralympics/athlete-features": "/player/sports",
    "/sports/video/paralympics/alpine-skiing": "/player/sports",
    "/sports/video/paralympics/snowboard": "/player/sports",
    "/sports/video/basketball": "/player/sports",
    "/sports/video/sliding": "/player/sports",
    "/sports/video/highlights": "/player/sports",
    "/sports/video/cycling": "/player/sports",
    "/sports/video/rugby": "/player/sports",
    "/sports/video/snowboarding": "/player/sports",
    "/arts/watch": "/player/arts",
    "/life/video": "/player/life",
    // Olympics Redirects
    "/sports/olympics/summer/cycling/bmx": "/sports/olympics/summer/cycling",
    "/sports/olympics/summer/cycling/mountain-bike":
        "/sports/olympics/summer/cycling",
    "/sports/olympics/summer/cycling/road": "/sports/olympics/summer/cycling",
    "/sports/olympics/summer/cycling/track": "/sports/olympics/summer/cycling",
    "/sports/olympics/summer/equestrian/dressage":
        "/sports/olympics/summer/equestrian",
    "/sports/olympics/summer/equestrian/eventing":
        "/sports/olympics/summer/equestrian",
    "/sports/olympics/summer/equestrian/show-jumping":
        "/sports/olympics/summer/equestrian",
    "/sports/olympics/summer/skateboarding/park":
        "/sports/olympics/summer/skateboarding",
    "/sports/olympics/summer/skateboarding/street":
        "/sports/olympics/summer/skateboarding",
    "/sports/olympics/summer/trackandfield/decathlon-heptathlon":
        "/sports/olympics/summer/trackandfield",
    "/sports/olympics/summer/trackandfield/field":
        "/sports/olympics/summer/trackandfield",
    "/sports/olympics/summer/trackandfield/road":
        "/sports/olympics/summer/trackandfield",
    "/sports/olympics/summer/trackandfield/track":
        "/sports/olympics/summer/trackandfield",
    "/sports/olympics/winter/skiing": "/sports/olympics/winter/alpine-skiing",
    "/sports/olympics/winter/sliding": "/sports/olympics/winter/bobsleigh",
    "/news/ask-cbc": "/news/canada/topic/Subject/Ask%20CBC",
    "/documentaries/hotdocsathome": "/documentaries/hotdocsoncbc",
    "/sports/soccer/mls": "/sports/soccer",
    "/sports/soccer/cpl": "/sports/soccer",
};
